import { v4 as uuidv4 } from "uuid";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as ItemCardDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sections/ItemCardBlock/ItemCardDefaultData";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";

export const createItemCardBlock = ({
  image = { signedId: "", placeholder: "" },
  title = "",
  description = "",
}): BaseBlock => ({
  ...ItemCardDefaultData,
  id: uuidv4(),
  props: {
    ...ItemCardDefaultData.props,
    image: {
      ...ItemCardDefaultData.props.image,
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: image.signedId,
          placeholder: image.placeholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "48px",
                height: "48px",
                minWidth: "none",
                minHeight: "none",
                maxWidth: "none",
                maxHeight: "none",
              },
            }),
          },
        }),
      ],
    },
    header: {
      ...ItemCardDefaultData.props.header,
      prop: "children",
      type: "children",
      value: [
        createH5Block({
          text: title,
        }),
      ],
    },
    description: {
      ...ItemCardDefaultData.props.description,
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: description,
          styles: {
            color: getColorOptions("var(--theme-website-color-text-muted)"),
          },
        }),
      ],
    },
  },
});
